import { Filter } from '@anytag/shared-molecules';
import { Template } from './Template';
import { useTrendingInfluencersFilter } from './hooks';

export const TrendingInfluencersFilter = () => {
  const { filter, setFilterForm } = useTrendingInfluencersFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template />
    </Filter.Provider>
  );
};

export * from './schemaTypes';
export { useTrendingInfluencersFilter };
